import { lazy, Suspense, useEffect, useState, type ReactNode } from 'react'
import { useLocation } from 'react-router-dom'

import type { OnlineAudioOptions } from '@/shared/realtime/media/livekit/liveKitConfig'
import { createMediaSessionBridge, MediaSessionContext } from './mediaSessionBridge'

const Host = lazy(() => import('./OnlineMediaSessionHost'))

export function isMediaSessionRoute(path: string) {
  return (
    /^\/online(?:\/room\/[^/]+)?\/?$/.test(path) ||
    /^\/strategy\/(?:2p|multi)\/?$/.test(path) ||
    /^\/puzzle\/(?:poster|poster-switch|united)-online\/?$/.test(path)
  )
}

export default function OnlineMediaSessionProvider({ children }: { children: ReactNode }) {
  const { pathname } = useLocation()
  const [options, setOptions] = useState<OnlineAudioOptions | null>(null)
  const [bridge] = useState(() => createMediaSessionBridge(setOptions))

  useEffect(() => {
    if (!isMediaSessionRoute(pathname)) bridge.stop()
  }, [bridge, pathname])

  return (
    <MediaSessionContext.Provider value={bridge}>
      {children}
      {options ? (
        <Suspense fallback={null}>
          <Host options={options} bridge={bridge} />
        </Suspense>
      ) : null}
    </MediaSessionContext.Provider>
  )
}
